// 사용자 표기용 유틸: "대표자 (업체명)" 포맷
export const formatUserName = (user, fallback = '-') => {
  if (!user) return fallback;
  const repr = user.name || '';
  const biz = user.business_name || user.businessName || user.company_name || '';
  if (repr && biz) return `${repr} (${biz})`;
  return repr || biz || fallback;
};
